import Immutable from 'immutable';

export interface RawProjectGroupUserAddition {
  email: string;
  id: string;
}

export interface ProjectGroupUserAdditionData {
  email: string;
  id: string;
}

const defaultValues: ProjectGroupUserAdditionData = {
  email: '',
  id: '',
};

export const ProjectGroupUserAdditionFactory = Immutable.Record(
  defaultValues,
  'ProjectGroupUserAddition'
);

export class ProjectGroupUserAddition extends ProjectGroupUserAdditionFactory {
  static deserialize(
    rawProjectGroupUserAddition: RawProjectGroupUserAddition
  ): ProjectGroupUserAddition {
    return new ProjectGroupUserAddition({
      ...rawProjectGroupUserAddition,
    });
  }

  serialize(): RawProjectGroupUserAddition {
    return this.toJS();
  }
}
